<script>
    import { classNames } from "../../utils";
    let cls = "sui-steps";
    export let direction = "vertical";
</script>

<div
    class={classNames({
        [cls]: cls,
        [`${cls}-${direction}`]: direction,
    })}
>
    <slot />
</div>

<style lang="less">
    @import "./steps.less";
</style>
